import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';

const uid = WixSDK.Utils.getInstanceValue('uid');
const rootCompId = getCompId();
export const REFRESH_EVENT = 'refreshOnLoginEvents';

export function storeForReload(data) {
  WixSDK.PubSub.publish(REFRESH_EVENT, {
    uid,
    stored: data,
    rootCompId,
  }, true);
}




// WEBPACK FOOTER //
// ./src/widget/utils/reload.js